/* unplugin-vue-components disabled */import { render } from "./HuddlePop.vue?vue&type=template&id=990e83a6&ts=true"
import script from "./HuddlePop.vue?vue&type=script&lang=ts"
export * from "./HuddlePop.vue?vue&type=script&lang=ts"

import "./HuddlePop.vue?vue&type=style&index=0&id=990e83a6&lang=scss"

import exportComponent from "/var/static/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.3.4_vue@3.3.4_webpack@4.46.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__